import { render, staticRenderFns } from "./NTop.vue?vue&type=template&id=bae8d45e&scoped=true"
import script from "./NTop.vue?vue&type=script&lang=js"
export * from "./NTop.vue?vue&type=script&lang=js"
import style0 from "./NTop.vue?vue&type=style&index=0&id=bae8d45e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae8d45e",
  null
  
)

export default component.exports